//import Dropzone from "react-dropzone"
import ProgressBar from './ProgressBar';
//import axios from "axios";
import  React, { useState, useEffect } from 'react';
import useDelete from '../hooks/useDelete';
import './upload.css';

//const allowedTypes = ["image/png", "image/jpeg"];

const FileUpload = ({ setPictresURL, picturesURL }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [deleteUrl, setDeleteUrl] = useState(null);
  const { errors } = useDelete(deleteUrl, setPictresURL, picturesURL);

  const MIME_TYPE = 'image/jpeg';
  const QUALITY = 0.7;
  const allowedTypes = ['image/png', 'image/jpeg'];

  const handleDelete = url => {
    setDeleteUrl(url);
    console.log('url', deleteUrl);
  };

  const handleChange = e => {
    let selectedFile = e.target.files[0];
    if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      const blobURL = URL.createObjectURL(selectedFile);
      const img = new Image();
      img.src = blobURL;
      img.onerror = function() {
        URL.revokeObjectURL(this.src);
        // Handle the failure properly
        console.log('Cannot load image');
      };
      img.onload = function() {
        URL.revokeObjectURL(this.src);
        const [newWidth, newHeight] = calculateSize(img, img.width, img.height);
        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        canvas.toBlob(
          blob => {
            // Handle the compressed image. es. upload or save in local state
            displayInfo('Original file', selectedFile);
            displayInfo('Compressed file', blob);
            console.log('Original file', selectedFile);
            blob.name = selectedFile.name;
            console.log('compreeeessss', blob);

            setFile(blob);
            //setError(null);
          },
          MIME_TYPE,
          QUALITY
        );
      };
    } else {
      setFile(null);
      setError('Please select an image file (png or jpeg)');
    }
  };

  function calculateSize(img, maxWidth, maxHeight) {
    let width = img.width;
    let height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }
    }
    return [width, height];
  }

  function displayInfo(label, file) {
    const p = `${label} - ${readableBytes(file.size)}`;

    console.log('display', p);
  }

  function readableBytes(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
  }

  return (
    <div>
    
        <label className="ImageInput">
          <input type="file" onChange={handleChange} />
          <span>+</span>
        </label>

        <div className="output">
          {error && <div className="error">{error}</div>}
          {file && (
            <ProgressBar
              file={file}
              setFile={setFile}
              setPictresURL={setPictresURL}
              picturesURL={picturesURL}
            />
          )}
          {picturesURL && (
            <div
              className="btn-group btn-group-sm"
              role="group"
              aria-label="Toolbar with button groups"
              style={{
                paddingTop: 2
              }}
            >
              {picturesURL.map((url, index) => (
                <button
                  type="button"
                  key={index}
                  className="btn btn-danger"
                  onClick={() => setDeleteUrl(url)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}
        </div>

    </div>
  );
};
export default FileUpload;
